module.exports = __webpack_public_path__ + "img/5.aa46f321.png";